import Splide from '@splidejs/splide';

// Функція для ініціалізації слайдера
function initializeSlider() {
    /**
     * Splide .articles-category mobile sliders executer
     */
    const splideElms = document.querySelectorAll('.articles-category-slider.splide');

    if (splideElms.length) {
        for (var i = 0; i < splideElms.length; i++) {
            new Splide(splideElms[i], {
                perPage: 1.2,
                focus: 0,
            }).mount();
        }
    }

    const slidersWithThumbnails = document.getElementsByClassName('image-slider-with-thumbnails');
    if (slidersWithThumbnails.length > 0) {
        for (let i = 0; i < slidersWithThumbnails.length; i++) {
            const secondarySliderEl = slidersWithThumbnails[i].querySelector('.secondary-slider');
            const secondarySlider = new Splide(secondarySliderEl, {
                rewind: true,
                fixedWidth: 100,
                fixedHeight: 64,
                isNavigation: true,
                gap: 10,
                focus: 'center',
                pagination: false,
                arrows: false,
                cover: true,
                breakpoints: {
                    '600': {
                        fixedWidth: 66,
                        fixedHeight: 40,
                    }
                }
            }).mount();

            const primarySliderEl = slidersWithThumbnails[i].querySelector('.primary-slider');
            const primarySlider = new Splide(primarySliderEl, {
                type: 'fade',
                // heightRatio: 0.5,
                rewind: true,
                pagination: false,
                arrows: true,
                cover: true,
            });

            // Set the thumbnails slider as a sync target and then call mount.
            primarySlider.sync(secondarySlider).mount();
        }
    }
}

// Виклик функції після підгрузки нового посту або вмикання AJAX-запиту
document.addEventListener("DOMContentLoaded", function () {
    let counter = 0;
    let counter2 = 0;

    const initialURL = window.location.href;
    let lastScrollTop = 0;

    function updateURLOnScroll() {
        const articles = document.querySelectorAll('.articleAnchor');

        // Callback function for Intersection Observer
        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const postURL = entry.target.getAttribute('data-posturl');
                    // console.log(postURL);
                    history.replaceState(null, null, postURL);
                }
            });
        };

        // Options for the observer (which part of the element should be visible)
        const observerOptions = {
            root: null, // Use the viewport as the container
            rootMargin: '0px',
            threshold: 0.1 // 10% of the element must be visible
        };

        // Create an Intersection Observer instance
        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // Observe each article
        articles.forEach(article => {
            observer.observe(article);
        });
    }

    function load_address(val, dataCountShow, showNext = true) {
        var value = val ? val : 0;

        var data = new FormData();
        data.append('action', 'get_more_post');
        data.append('id', value);
        data.append('showNext', showNext);


        var xhr = new XMLHttpRequest();
        xhr.open('POST', myajax.url, true);
        if (counter < dataCountShow) {
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    if (response) {
                        if (response == '') {
                            return 'State not found. Please try again.';
                        }
                        var contacts = document.getElementById('more-item');
                        contacts.innerHTML = contacts.innerHTML + response;
                        initializeSlider();
                        // Зміна URL при завантаженні нової новини
                        let newUrl = extractNewUrl(response); // Функція для вилучення нового URL з відповіді
                        if (newUrl) {
                            history.pushState({url: newUrl}, null, newUrl);
                        }
                        updateURLOnScroll();
                    } else {
                        console.log('Немає');
                    }
                } else {
                    console.log('Request failed.  Returned status of ' + xhr.status);
                }
            };
            counter++;
        } else {
            // Отримати елемент з id "click-me"
            var clickMeElement = document.getElementById('click-me');
            // Очистити текст всередині цього елемента
            clickMeElement.textContent = '';
        }
        xhr.onerror = function () {
            console.log('Request failed');
        };
        xhr.send(data);
    }

    function load_address_5(val, dataCountShow, showNext = true) {
        console.log('Work Loader');
        var value = val ? val : 0;
        var data = new FormData();
        data.append('action', 'get_more_post_5');
        data.append('id', value);
        data.append('count', dataCountShow);
        data.append('showNext', showNext);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', myajax.url, true);
        if (counter2 >= 0) {
            xhr.onload = function () {
                console.log(xhr.status);
                console.log(xhr);
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    if (response) {
                        if (response == '') {
                            return 'State not found. Please try again.';
                        }
                        var contacts = document.getElementById('more-item');

                        contacts.innerHTML = contacts.innerHTML + response;
                        initializeSlider();
                        // Зміна URL при завантаженні нової новини
                        let newUrl = extractNewUrl(response); // Функція для вилучення нового URL з відповіді
                        if (newUrl) {
                            history.pushState({url: newUrl}, null, newUrl);
                        }
                        updateURLOnScroll();


                        var clickMeElement = document.getElementById('click-me');
                        // Очистити текст всередині цього елемента
                        clickMeElement.textContent = '';
                    } else {
                        console.log('Немає');
                    }
                } else {
                    console.log('Request failed.  Returned status of ' + xhr.status);
                }
            };
            counter2++;
        } else {
            // Отримати елемент з id "click-me"
            var clickMeElement = document.getElementById('click-me');
            // Очистити текст всередині цього елемента
            clickMeElement.textContent = '';
        }
        xhr.onerror = function () {
            console.log('Request failed');
        };
        xhr.send(data);
    }function load_address_5(val, dataCountShow, showNext = true) {
        console.log('Work Loader');
        var value = val ? val : 0;
        var data = new FormData();
        data.append('action', 'get_more_post_5');
        data.append('id', value);
        data.append('count', dataCountShow);
        data.append('showNext', showNext);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', myajax.url, true);
        if (counter2 >= 0) {
            xhr.onload = function () {
                console.log(xhr.status);
                console.log(xhr);
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    if (response) {
                        if (response == '') {
                            return 'State not found. Please try again.';
                        }
                        var contacts = document.getElementById('more-item');

                        contacts.innerHTML = contacts.innerHTML + response;
                        initializeSlider();
                        // Зміна URL при завантаженні нової новини
                        let newUrl = extractNewUrl(response); // Функція для вилучення нового URL з відповіді
                        if (newUrl) {
                            history.pushState({url: newUrl}, null, newUrl);
                        }
                        updateURLOnScroll();


                        var clickMeElement = document.getElementById('click-me');
                        // Очистити текст всередині цього елемента
                        clickMeElement.textContent = '';
                    } else {
                        console.log('Немає');
                    }
                } else {
                    console.log('Request failed.  Returned status of ' + xhr.status);
                }
            };
            counter2++;
        } else {
            // Отримати елемент з id "click-me"
            var clickMeElement = document.getElementById('click-me');
            // Очистити текст всередині цього елемента
            clickMeElement.textContent = '';
        }
        xhr.onerror = function () {
            console.log('Request failed');
        };
        xhr.send(data);
    }

    function extractNewUrl(response) {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;
        let newUrlElement = tempDiv.querySelector('[data-url]');
        return newUrlElement ? newUrlElement.getAttribute('data-url') : null;
    }

    let countLoad = 0;

    const observer = new IntersectionObserver((entries) => {
        function loadMore() {
            let clickMeElement = document.getElementById('click-me');
            let dataCountShow = clickMeElement.getAttribute('data-counter');

            if (dataCountShow != 0) {
                const postSection = document.querySelector('.articleAnchor[data-loadpost]');
                let loadPostValue = ' ';
                if (postSection) {
                    loadPostValue = postSection.getAttribute('data-loadpost');
                }

                if (countLoad == 0 && loadPostValue != '') {
                    // dataCountShow = dataCountShow;
                    load_address(loadPostValue, dataCountShow, 'false');

                } else {
                    let clickMeElement = document.getElementById('click-me');
                    let nextShow = clickMeElement.getAttribute('data-next');
                    // load_address(nextShow, dataCountShow, 'true');

                    clickMeElement.setAttribute('data-next', '');
                    clickMeElement.setAttribute('data-counter', 0);
                    load_address_5(nextShow, dataCountShow, true);

                    // setTimeout(function () {
                    //     let articleItems = document.querySelectorAll('#more-item .articleAnchor');
                    //     let lastArticleItem = articleItems[articleItems.length - 1];
                    //     let dataNextAttributeValue = lastArticleItem.getAttribute('data-next');
                    //     let clickMeElement = document.getElementById('click-me');
                    //     clickMeElement.setAttribute('data-next', dataNextAttributeValue);
                    // }, 1500);
                }

            }
            countLoad++;
        }

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadMore();
            }
        }, {
            root: null, // Спостереження за вікном перегляду
            rootMargin: '0px 0px 600px 0px', // Початок підвантаження на 500 пікселів раніше
            threshold: 0 // Тільки один піксель повинен бути у видимій зоні для активації
        });
    });

    const section = document.getElementById('click-me');
    if (section) {
        observer.observe(section);
    } else {
        // console.error('Element with id "click-me" not found.');
    }
});

// Додаємо обробник подій до батьківського контейнера, наприклад, document.body
document.body.addEventListener('click', function (event) {
    // Перевіряємо, чи клікнуто на елемент з класом '.copy-url'
    if (event.target && event.target.classList.contains('copy-url')) {
        event.preventDefault(); // Заборона стандартної дії посилання

        // Отримання батьківського елемента <a> з класом '.social-share__link'
        var parentLink = event.target.closest('a.social-share__link');

        // Перевірка, чи знайдено батьківський елемент
        if (parentLink) {
            // Отримання значення дата-атрибута 'data-url' з батьківського елемента
            var urlToCopy = parentLink.getAttribute('data-url');

            // Створення нового елементу для копіювання URL в буфер обміну
            var tempInput = document.createElement('input');
            tempInput.setAttribute('value', urlToCopy);
            document.body.appendChild(tempInput);

            // Вибір тексту у введенні
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); /* Для мобільних пристроїв */

            // Копіювання тексту у вибраний діапазон
            document.execCommand('copy');

            // Видалення тимчасового елементу
            document.body.removeChild(tempInput);

            // Виведення повідомлення про копіювання
            alert('URL скопійовано в буфер обміну: ' + urlToCopy);
        }
    }
});